import { motion } from 'motion/react';
import { FC, useContext } from 'react';

import { truncateText } from '@/Utils/textUtils';

import classes from './P2PAdminPanel.module.css';
import { P2PContext } from './P2PContext';

interface IProps {
    title: string;
    index: number;
}

const P2PListItem: FC<IProps> = props => {
    const { title, index } = props;

    const context = useContext(P2PContext);
    const { setActiveUserItem, activeCategory, setActiveCategory } = context;

    const chooseCateg = () => {
        const categTrimed = title.toLocaleLowerCase().trim();
        setActiveUserItem(null);
        if (activeCategory !== categTrimed) {
            setTimeout(() => {
                setActiveCategory(categTrimed);
            }, 100);
        }
    };

    return (
        <motion.li
            initial={{ opacity: 0, x: 0 }}
            exit={{ opacity: 0.2, x: 5 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.07 * index }}
            style={{ textTransform: 'capitalize' }}
            onClick={chooseCateg}
            className={`${
                activeCategory.toLowerCase() === title.toLowerCase()
                    ? classes['active']
                    : ''
            } ${classes['list-item']}`}>
            {truncateText(title, 20)}
        </motion.li>
    );
};

export default P2PListItem;
